import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import PawPrint from "../components/display/PawPrint";
import { ThemeContext } from "./ThemeContext";
export const LoadingContext = React.createContext();

export default function Loading({ children }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const { mode } = React.useContext(ThemeContext);
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      <Backdrop
        sx={{ backgroundColor: mode == "dark" ? "#191919" : "#fff", zIndex: 99 }}
        open={isLoading}
      >
        <PawPrint />
      </Backdrop>
      {children}
    </LoadingContext.Provider>
  );
}
